export default "Les fiches CEE IND permettent aux sites industriels d'obtenir des primes pour leurs travaux d'économies d'énergie (variateurs, récupération chaleur, compresseurs). Calculez votre prime.";
